module.exports = __webpack_public_path__ + "static/media/meter-reader-balanced-black.f5da6cf8.png";